export const MODULE_CATALOG = [
  {
    id: 'primary_media',
    icon: '+',
    label: 'Photo Story',
    shortLabel: 'Cover',
    role: 'Start with the first photo or video they should see.',
    tier: 'core',
    bestFormats: ['layer_by_layer', 'memory_page', 'gift_reveal', 'photo_journey', 'keepsake_moment'],
  },
  {
    id: 'text',
    icon: 'T',
    label: 'Letter',
    shortLabel: 'Story',
    role: 'Write the personal message that makes the gift feel made for them.',
    tier: 'core',
    bestFormats: ['layer_by_layer', 'memory_page', 'gift_reveal', 'photo_journey', 'letters_for_later', 'keepsake_moment'],
  },
  {
    id: 'surprise_box',
    icon: '*',
    label: 'Open When',
    shortLabel: 'Reveal',
    role: 'Hide a note they can open slowly, like a small private reveal.',
    tier: 'core',
    bestFormats: ['layer_by_layer', 'gift_reveal', 'letters_for_later'],
  },
  {
    id: 'voice_postcard',
    icon: 'V',
    label: 'Voice + Photo Postcard',
    shortLabel: 'Voice',
    role: 'Record the part that feels warmer when heard than typed.',
    tier: 'core',
    bestFormats: ['layer_by_layer', 'memory_page', 'gift_reveal', 'photo_journey', 'letters_for_later', 'surprise_reveal'],
  },
  {
    id: 'timeline',
    icon: '1',
    label: 'Timeline',
    shortLabel: 'Time',
    role: 'Turn important dates and milestones into a simple chronological path.',
    tier: 'advanced',
    bestFormats: ['layer_by_layer', 'photo_journey', 'memory_page'],
  },
  {
    id: 'guestbook',
    icon: 'G',
    label: 'Blessing Wall',
    shortLabel: 'Bless',
    role: 'Collect short messages from invited family or friends.',
    tier: 'core',
    bestFormats: ['layer_by_layer', 'memory_page', 'gift_reveal', 'keepsake_moment'],
  },
  {
    id: 'keepsake_poster',
    icon: 'K',
    label: 'Keepsake Card',
    shortLabel: 'Final',
    role: 'End with a saveable final card they can keep on their phone.',
    tier: 'core',
    bestFormats: ['layer_by_layer', 'memory_page', 'gift_reveal', 'photo_journey', 'letters_for_later', 'keepsake_moment'],
  },
  {
    id: 'song_dedication',
    icon: 'S',
    label: 'Music Moment',
    shortLabel: 'Music',
    role: 'Attach a song or dedication that carries the feeling.',
    tier: 'advanced',
    bestFormats: ['layer_by_layer', 'gift_reveal', 'keepsake_moment'],
  },
  {
    id: 'then_now',
    icon: 'N',
    label: 'Then & Now',
    shortLabel: 'Compare',
    role: 'Place two photos side by side as a swipeable before-and-after memory.',
    tier: 'advanced',
    bestFormats: ['layer_by_layer', 'gift_reveal', 'photo_journey', 'memory_page'],
  },
  {
    id: 'frame_gallery',
    icon: 'F',
    label: 'Frame Gallery',
    shortLabel: 'Frame',
    role: 'Turn one photo into a framed keepsake with wood, film, museum, or paper styles.',
    tier: 'advanced',
    bestFormats: ['layer_by_layer', 'memory_page', 'keepsake_moment', 'photo_journey'],
  },
  {
    id: 'memory_map',
    icon: 'M',
    label: 'Memory Map',
    shortLabel: 'Map',
    role: 'Add a path of places, dates, and meaningful stops without making it a core chapter.',
    tier: 'advanced',
    bestFormats: ['layer_by_layer', 'photo_journey', 'memory_page', 'keepsake_moment'],
  },
  {
    id: 'flip_card',
    icon: '?',
    label: 'Tiny Museum',
    shortLabel: 'Capsule',
    role: 'Frame a photo, note, date, or tiny detail like a private exhibit.',
    tier: 'advanced',
    hiddenFromBuilder: true,
    bestFormats: ['layer_by_layer', 'letters_for_later', 'gift_reveal', 'surprise_reveal'],
  },
  {
    id: 'tiny_museum',
    icon: 'U',
    label: 'Tiny Museum',
    shortLabel: 'Museum',
    role: 'Frame a tiny private exhibit: a detail, message, date, or keepsake memory.',
    tier: 'advanced',
    bestFormats: ['layer_by_layer', 'letters_for_later', 'gift_reveal', 'surprise_reveal', 'keepsake_moment'],
  },
  {
    id: 'reaction',
    icon: 'R',
    label: 'Polaroid Booth',
    shortLabel: 'Booth',
    role: 'Let the recipient add a selfie, emoji, or quick reply as a keepsake moment.',
    tier: 'advanced',
    hiddenFromBuilder: true,
    bestFormats: ['layer_by_layer', 'gift_reveal', 'photo_journey', 'surprise_reveal'],
  },
  {
    id: 'polaroid_booth',
    icon: 'P',
    label: 'Polaroid Booth',
    shortLabel: 'Booth',
    role: 'Let the recipient add a selfie, emoji, or quick reply as a keepsake moment.',
    tier: 'advanced',
    bestFormats: ['layer_by_layer', 'gift_reveal', 'photo_journey', 'surprise_reveal'],
  },
  {
    id: 'ai_generator',
    icon: 'AI',
    label: 'AI Studio',
    shortLabel: 'AI',
    role: 'Draft gift writing and check Firebase AI provider readiness from one editor-only panel.',
    tier: 'advanced',
    bestFormats: ['layer_by_layer', 'memory_page', 'gift_reveal', 'photo_journey', 'letters_for_later', 'keepsake_moment'],
  },
];

export const HIDDEN_LEGACY_MODULES = [
  {
    id: 'wisdom',
    label: 'Wisdom',
    shortLabel: 'Wisdom',
    reason: 'Legacy quote module. Keep rendering old gifts, but do not offer it in the main builder.',
  },
  {
    id: 'product_identity',
    label: 'Product Info',
    shortLabel: 'Product',
    reason: 'Legacy product-identification module. The new gift builder starts with media and story instead.',
  },
  {
    id: 'love_coupons',
    label: 'Love Coupons',
    shortLabel: 'Coupons',
    reason: 'Legacy utility module. It can return later as an optional add-on, not a core gift chapter.',
  },
  {
    id: 'coupons',
    label: 'Coupons',
    shortLabel: 'Coupons',
    reason: 'Legacy alias for Love Coupons.',
  },
  {
    id: 'love_promise',
    label: 'Love Promise',
    shortLabel: 'Promise',
    reason: 'Legacy relationship module. It is too specific for the main mobile gift flow.',
  },
  {
    id: 'instant_camera',
    label: 'Instant Camera',
    shortLabel: 'Camera',
    reason: 'Legacy camera module. Photo Story now owns mobile photo capture and upload.',
  },
];

export const LEGACY_MODULE_AUDIT = {
  renderOnly: [
    'wisdom',
    'product_identity',
    'product_info',
    'product',
    'love_coupons',
    'coupons',
    'love_promise',
    'promise',
    'instant_camera',
    'camera',
    'media',
    'media_module',
    'legacy_media',
    'media_combo',
    'media_combo_module',
    'legacy_media_combo',
    'primary_media_legacy',
    'legacy_primary_media',
    'time_together',
  ],
  advanced: [
    'song_dedication',
    'flip_card',
    'reaction',
    'timeline',
    'geometric_decrypt',
    'unlock_sequence',
    'shared_album',
    'hero_media',
    'video_player',
    'media_card',
  ],
  archivedFiles: [
    'components/legacy/WisdomModule.js',
    'components/legacy/ProductIdentityModule.js',
    'components/legacy/LoveCouponsModule.js',
    'components/legacy/LovePromiseModule.js',
    'components/legacy/InstantCameraModule.js',
    'components/legacy/ARViewer.js',
    'components/legacy/ScreenshotModule.js',
    'components/legacy/MediaComboModule.js',
    'components/legacy/AffectionTapperModule.js',
    'components/legacy/TextContentModule.js',
    'components/legacy/LayeredGiftBox.js',
    'components/legacy/CandleRitual.js',
    'components/legacy/NFCWelcomeGuide.js',
    'components/legacy/CustomTemplateModal.js',
    'components/legacy/MediaModule.js',
    'components/legacy/PrimaryMediaModule.js',
  ],
  removedServices: [
    'MonetizationService',
  ],
};

export const HIDDEN_MAIN_FLOW_MODULE_IDS = [
  ...HIDDEN_LEGACY_MODULES.map((module) => module.id),
  ...MODULE_CATALOG.filter((module) => module.hiddenFromBuilder).map((module) => module.id),
];
export const isHiddenMainFlowModule = (moduleType) => HIDDEN_MAIN_FLOW_MODULE_IDS.includes(moduleType);

export const CORE_MODULES = MODULE_CATALOG.filter((module) => module.tier === 'core' && !module.hiddenFromBuilder);
export const ADVANCED_MODULES = MODULE_CATALOG.filter((module) => module.tier === 'advanced' && !module.hiddenFromBuilder);

export const MOBILE_SIGNATURE_MODULES = [
  'timeline',
  'memory_map',
  'tiny_museum',
  'polaroid_booth',
  'then_now',
  'frame_gallery',
  'song_dedication',
];

export const MOBILE_BUILDER_MODULES = [
  'primary_media',
  'text',
  'surprise_box',
  'voice_postcard',
  'timeline',
  'memory_map',
  'tiny_museum',
  'polaroid_booth',
  'guestbook',
  'keepsake_poster',
  'ai_generator',
].filter((moduleType) => !isHiddenMainFlowModule(moduleType));

export const getModuleMeta = (moduleType) => {
  const hiddenLegacyModule = HIDDEN_LEGACY_MODULES.find((module) => module.id === moduleType);
  if (hiddenLegacyModule) {
    return {
      ...hiddenLegacyModule,
      icon: 'L',
      role: hiddenLegacyModule.reason,
      tier: 'legacy',
      hiddenFromBuilder: true,
      bestFormats: [],
    };
  }

  return MODULE_CATALOG.find((module) => module.id === moduleType) || {
    id: moduleType,
    icon: '?',
    label: moduleType,
    shortLabel: moduleType,
    role: 'Custom gift module.',
    tier: 'advanced',
    bestFormats: [],
  };
};

export const getRecommendedModulesForFormat = (format, fallback = []) => {
  if (fallback.length > 0) return fallback.filter((moduleType) => !isHiddenMainFlowModule(moduleType));
  return CORE_MODULES
    .filter((module) => module.bestFormats.includes(format))
    .map((module) => module.id);
};

export const getAdvancedModulesForFormat = (format, recommended = []) => {
  return ADVANCED_MODULES
    .filter((module) => !recommended.includes(module.id))
    .sort((a, b) => {
      const aMatch = a.bestFormats.includes(format) ? 0 : 1;
      const bMatch = b.bestFormats.includes(format) ? 0 : 1;
      return aMatch - bMatch;
    });
};
